module.exports = __webpack_public_path__ + "img/photo-user-4.f8c65ddb.svg";